export default __webpack_public_path__ + "static/media/napolitana.103cc3da.jpg";